'use client';

import { cn } from '@insta-club/utilities';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

interface Props extends React.PropsWithChildren {
    open: boolean;
    duration?: number;
    className?: string;
    collapsedSize?: number;
}

const Collapse: React.FC<Props> = ({ open = false, children, duration = 0.25, className, collapsedSize = 0 }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (ref.current) {
            setHeight(ref.current.scrollHeight);
        }
    }, [open, children]);

    return (
        <div className={cn('overflow-hidden transition-all ease-in-out', className)}>
            <motion.div
                ref={ref}
                initial={false}
                animate={{
                    height: open ? height : collapsedSize,
                    opacity: open ? 1 : collapsedSize > 0 ? 1 : 0
                }}
                transition={{ duration, ease: 'easeInOut' }}
                className='overflow-hidden'
            >
                <div>{children}</div>
            </motion.div>
        </div>
    );
};

export default Collapse;

